import {
  useCookie,
  useState,
  useNuxtApp,
  useRuntimeConfig
} from "#app";
export const useDirectusTokens = (useStaticToken) => {
  const directusConfig = useRuntimeConfig().public.directus;
  const {
    authStateName,
    mode,
    refreshTokenCookieName,
    authTokenCookieName,
    cookieHttpOnly: httpOnly,
    cookieSameSite: sameSite,
    cookieSecure: secure
  } = directusConfig.authConfig;
  const { runWithContext } = useNuxtApp();
  const tokens = useState(authStateName, () => null);
  function refreshToken(maxAge) {
    const cookie = useCookie(refreshTokenCookieName, { maxAge, httpOnly, sameSite, secure });
    return cookie;
  }
  function accessToken(maxAge) {
    const cookie = useCookie(authTokenCookieName, { maxAge, httpOnly, sameSite, secure });
    return cookie;
  }
  function get() {
    return runWithContext(() => {
      if (useStaticToken === true || typeof useStaticToken === "string" || !tokens.value?.access_token && useStaticToken !== false) {
        return {
          access_token: typeof useStaticToken === "string" ? useStaticToken : directusConfig.staticToken,
          refresh_token: null,
          expires_at: null,
          expires: null
        };
      } else if (tokens.value) {
        return {
          access_token: tokens.value.access_token,
          refresh_token: mode === "json" ? refreshToken().value : tokens.value.refresh_token,
          expires_at: tokens.value.expires_at,
          expires: tokens.value.expires
        };
      } else {
        return null;
      }
    });
  }
  function set(value) {
    runWithContext(() => {
      tokens.value = value;
      if (mode === "json") {
        refreshToken(value?.expires || void 0).value = value?.refresh_token;
        accessToken(value?.expires || void 0).value = value?.access_token;
      }
    });
  }
  return {
    get,
    set,
    tokens,
    refreshToken
  };
};
